import { useEffect, useState } from "react";
import { Column, GridView, Griew, Response } from "react-griew";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import OutboundRequestLogService from "../../service/outbound-request-log-service";
import Pasoonate from "pasoonate";
import DetailsOutboundRequestLogWindow from "./DetailsOutboundRequestLogWindow";

const outboundRequestLogService = new OutboundRequestLogService();
const griew = new Griew();

loadDictionary('outbound-request-log-main-page');

function OutboundRequestLogMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDetailsWindow, setIsOpenDetailsWindow] = useState(false);
  const [selectedLogId, setSelectedLogId] = useState(null);
  
  const reloadList = () => { 
    setIsLoading(true); 

    griew.orders.add('id', 'DESC');
    griew.refresh();
  };

  const handleOpenDetailsWindow = (logId) => {
    setSelectedLogId(logId);
    setIsOpenDetailsWindow(true);
  };

  const handleCloseDetailsWindow = () => {
    setIsOpenDetailsWindow(false);
    reloadList();
  };

  useEffect(() => {
    prepareGriew(setCount, setIsLoading, handleOpenDetailsWindow);
    // eslint-disable-next-line react-hooks/set-state-in-effect
    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body p-3">
        <h4 className="page-title">{i18n.t("outbound-request-log-main-page.page_title")}</h4>
        <div className="header-content"></div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="mt-1 mb-3">{i18n.t("outbound-request-log-main-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <DetailsOutboundRequestLogWindow key={`details-${selectedLogId}`} isOpenWindow={isOpenDetailsWindow} onCloseWindow={handleCloseDetailsWindow} requestLogId={selectedLogId} />
    </div>
  );
}

const prepareGriew = (setCount, setIsLoading, handleOpenDetailsWindow) => {
  const list = [
    {
      name: "id",
      caption: i18n.t("outbound-request-log-main-page.id"),
      schema: "OutboundRequestLog",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "service_name",
      caption: i18n.t("outbound-request-log-main-page.service_name"),
      schema: "OutboundRequestLog",
      type: Column.STRING,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: false,
    },
    {
      name: "url",
      caption: i18n.t("outbound-request-log-main-page.url"),
      schema: "OutboundRequestLog",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => {
        return (<div dir="ltr" className="text-left">{value}</div>);
      }
    },
    {
      name: "status_code",
      caption: i18n.t("outbound-request-log-main-page.status_code"),
      schema: "OutboundRequestLog",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "execution_time",
      caption: i18n.t("outbound-request-log-main-page.execution_time"),
      schema: "OutboundRequestLog",
      type: Column.NUMBER,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => {
        return (<span dir="ltr">{Number(value).toFixed(3)}</span>);
      }
    },
    {
      name: "created_at",
      caption: i18n.t("outbound-request-log-main-page.created_at"),
      schema: "OutboundRequestLog",
      type: Column.DATETIME,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd HH:mm:ss");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "",
      caption: i18n.t("outbound-request-log-main-page.actions"),
      schema: "OutboundRequestLog",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, log) => { 
        const detailsButton = <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenDetailsWindow(log.id) }}>{i18n.t("outbound-request-log-main-page.details_button")}</button>;

        return (
          <>
          {detailsButton}          
          </>
        );
      }
    }
  ];
  const callback = (promis) => {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);

      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };

  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
      function: (query) => outboundRequestLogService.gridview(query),
      callback: callback
  };
};

export default OutboundRequestLogMainPage;